import React, { useEffect, useMemo, useState } from 'react';
import { makeStyles } from '@mui/styles';
import {
    Grid, ButtonGroup, Button, Autocomplete, TextField, Fade,
    Menu, MenuItem, Dialog, DialogTitle, DialogActions,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import ArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import { CATEGORY } from './constants';

const useStyles = makeStyles((theme) => ({
    btnDelete: {
        padding: '0 !important',
    },
    value: {
        minWidth: 200,
    },
    dialog: {
        minWidth: 400,
    },
}));

const Entry = ({ show, current, setCurrent, onHover, onDelete }) => {
    const classes = useStyles();

    const [anchorCategory, setAnchorCategory] = useState(null);
    const [anchorKey, setAnchorKey] = useState(null);

    const [category, setCategory] = useState('Workload Label');
    const [key, setKey] = useState('');

    const [operator, setOperator] = useState(true);
    const [value, setValue] = useState('');

    const [openDialog, setOpenDialog] = useState(false);

    useEffect(() => {
        if (!category || !value) {
            return;
        }
        setCurrent({ category, key, operator, value });
    }, [category, key, operator, value, setCurrent]);

    useEffect(() => {
        if (!current) {
            return;
        }
        setCategory(current.category);
        setKey(current.key);
        setOperator(current.operator);
        setValue(current.value);
    }, [current]);

    useEffect(() => {
        if (!category) {
            return;
        }
        const keys = Array.isArray(CATEGORY[category]) ? [] : Object.keys(CATEGORY[category]);
        setKey(keys[0] || undefined);
    }, [category]);

    const valueOptions = useMemo(() => {
        if (!category) {
            return [];
        }
        if (Array.isArray(CATEGORY[category])) {
            return CATEGORY[category];
        }
        return CATEGORY[category][key] || [];
    }, [category, key]);

    useEffect(() => {
        setValue(valueOptions[0]);
    }, [valueOptions]);

    const handleClose = () => {
        setAnchorCategory(null);
        setAnchorKey(null);
    }
    const handleChangeCategory = (name) => () => {
        setCategory(name);
        handleClose();
    };
    const handleChangeKey = (name) => () => {
        setKey(name);
        handleClose();
    };
    const handleDelete = () => {
        onDelete && onDelete();
        setOpenDialog(false);
    };

    return (
        <>
            <Grid container spacing={1} onClick={(e) => e.stopPropagation()} onMouseOver={onHover} style={{ width: 'auto' }}>
                <Grid item>
                    <Fade orientation="horizontal" in={!!show}>
                        <ButtonGroup variant="contained">
                            <Button className={classes.btnDelete} color="error" onClick={() => setOpenDialog(true)}><DeleteIcon fontSize="small" /></Button>
                            <Button className="btn" endIcon={<ArrowDownIcon />} onClick={e => setAnchorCategory(e.currentTarget)}>{category}</Button>
                            {!Array.isArray(CATEGORY[category]) && (
                                <Button className="btn" endIcon={<ArrowDownIcon />} onClick={e => setAnchorKey(e.currentTarget)}>{key}</Button>
                            )}
                            <Button className="btn" color={operator ? 'primary' : 'secondary'} onClick={() => setOperator(!operator)}>{operator ? 'is' : 'not'}</Button>
                        </ButtonGroup>
                    </Fade>
                </Grid>
                
                {value && (
                    <Grid item>
                        <Fade orientation="horizontal" in={!!show}>
                            <Autocomplete
                                options={valueOptions}
                                renderInput={(params) => <TextField {...params} label="value" variant="outlined" size="small" />}
                                value={value}
                                onChange={(_, newValue) => setValue(newValue)}
                                disableClearable
                                className={classes.value}
                            />
                        </Fade>
                    </Grid>
                )}
            </Grid>

            <Menu
                anchorEl={anchorCategory}
                open={!!anchorCategory}
                onClose={handleClose}
                onClick={(e) => e.stopPropagation()}
            >
                {Object.keys(CATEGORY).map(name => (
                    <MenuItem key={`menu-item-category-${name}`} onClick={handleChangeCategory(name)}>{name}</MenuItem>
                ))}
            </Menu>
            <Menu
                anchorEl={anchorKey}
                open={!!anchorKey}
                onClose={handleClose}
                onClick={(e) => e.stopPropagation()}
            >
                {Object.keys(CATEGORY[category]).map(name => (
                    <MenuItem key={`menu-item-key-${name}`} onClick={handleChangeKey(name)}>{name}</MenuItem>
                ))}
            </Menu>

            <Dialog open={openDialog} onClose={() => setOpenDialog(false)} onClick={(e) => e.stopPropagation()} classes={{ paper: classes.dialog }}>
                <DialogTitle>Delete This Entry?</DialogTitle>
                <DialogActions>
                    <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
                    <Button color="error" variant="contained" onClick={handleDelete}>Confirm</Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default Entry;
